import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon, DownloadIcon, EyeIcon, GiftIcon, LayersIcon, SparklesIcon } from 'lucide-react';
import { CheckoutButton } from './Button';
import { ProductName } from './ProductName';
import { Ornament } from './Ornament';
import { PriceTag } from './PriceTag';
const includes = [{
  label: 'Volume 1 — Salsa Foundations, Timing, Footwork & Shines'
}, {
  label: 'Volume 2 — Bachata Foundations, Body Movement, Footwork & Styling'
}, {
  label: 'Volume 3 — Partnerwork, Connection, Leading, Following & Turns'
}, {
  label: 'Volume 4 — Musicality, Combinations & Social Dance Development'
}, {
  label: 'Volume 5 — Instructor Method, Corrections, Class Structure & Student Progression'
}, {
  label: 'Volume 6 — 150 Ready-to-Teach Salsa & Bachata Classes'
}, {
  label: '100% Visual Core Teaching System'
}, {
  label: 'Beginner-to-Advanced Progressions'
}, {
  label: 'Salsa + Bachata in One Complete System'
}, {
  label: '30 Ready-to-Use Warm-Ups for Salsa & Bachata',
  bonus: true
}, {
  label: 'Mixed-Level Class Adaptation Guide',
  bonus: true
}, {
  label: 'Social Dance Etiquette & Floorcraft Guide',
  bonus: true
}, {
  label: 'Private Lessons & Workshop Teaching Blueprint',
  bonus: true
}, {
  label: 'Student Engagement & Retention Guide for Dance Instructors',
  bonus: true
}, {
  label: 'Immediate Digital Access'
}, {
  label: 'PDF Format'
}];
const alternatives = ['Salsa technique.', 'Bachata technique.', 'Partnerwork.', 'Musicality.', 'Instructor methodology.', '150 complete classes.'];
const trustItems = [{
  icon: LayersIcon,
  label: '6 Complete Instructor Volumes'
}, {
  icon: BookOpenIcon,
  label: '150 Ready-to-Teach Classes'
}, {
  icon: EyeIcon,
  label: '100% Visual Core Material'
}, {
  icon: GiftIcon,
  label: '5 Professional Bonus Guides'
}, {
  icon: DownloadIcon,
  label: 'Immediate Access'
}];
export function PricingSection() {
  return <section id="pricing" className="bg-ink px-4 py-20 text-cream sm:py-28" data-id="element-216" data-mp="hi193tdbhqfn">
      <div className="mx-auto max-w-3xl" data-id="element-217" data-mp="hfoxdxy5kcb1">
        <div className="text-center" data-id="element-218" data-mp="mh4fbh51a2p7">
          <p className="text-sm font-semibold uppercase tracking-[0.18em] text-cream/70" data-id="element-219" data-mp="mg33hag71c6f">
            Your complete Salsa & Bachata Instructor Ready package
          </p>
          <h2 className="mt-3 text-3xl font-semibold text-gold sm:text-4xl" data-id="element-220" data-mp="chncr8l2w4xg">
            A Complete 6-in-1 Visual Teaching System —{' '}
            <span className="italic text-champagne" data-id="element-221" data-mp="3uul6gxra21j6">Ready for Your Next Class</span>
          </h2>
          <Ornament className="mt-5" data-id="element-222" data-mp="3k37lok3hohk" />
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mt-12 rounded-2xl border border-gold/50 bg-ink-soft shadow-luxe" data-id="element-223" data-mp="3kz9qyd81oqad">
          <div className="absolute -top-3.5 left-1/2 inline-flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full border border-gold bg-wine px-3.5 py-1 text-xs font-semibold uppercase tracking-[0.1em] text-cream" data-id="element-224" data-mp="3fy3vi7n02ox5">
            <SparklesIcon size={14} className="text-champagne" aria-hidden="true" data-id="element-225" data-mp="2secz6grpbzz5" />{' '}
            6-in-1 System
          </div>
          <div className="p-6 text-center sm:p-10" data-id="element-226" data-mp="31c6txn9tilk7">
            <h3 className="text-3xl font-semibold text-cream" data-id="element-227" data-mp="31bdk2dfkbfxu">
              <ProductName accentClassName="text-champagne" data-id="element-228" data-mp="3g8xj73ps2gw3" />
            </h3>
            <p className="mt-3 text-xs font-bold tracking-[0.16em] text-gold" data-id="element-229" data-mp="3bb4hamvic91m">
              6 VOLUMES. 150 CLASSES. 5 BONUSES. ONE COMPLETE SYSTEM.
            </p>
            <p className="mt-7 text-left text-sm font-semibold text-cream sm:mx-auto sm:max-w-xl" data-id="element-230" data-mp="3p4dii09axo92">
              You receive:
            </p>
            <ul className="mx-auto mt-3 grid max-w-xl gap-y-2.5 border-y border-gold/25 py-6 text-left" data-id="element-231" data-mp="2uja9bmfrq15">
              {includes.map(item => {
              const Icon = item.bonus ? GiftIcon : CheckIcon;
              return <li key={item.label} className="flex gap-2.5 text-sm leading-6 text-cream/85" data-id="element-232" data-mp="hxkri7qwlwuz">
                    <Icon size={16} strokeWidth={1.75} className="mt-1 shrink-0 text-gold" aria-hidden="true" data-id="element-233" data-mp="qpw871w7u5xr" />
                    <span data-id="element-234" data-mp="3v5nv7uuytuam">
                      {item.bonus && <span className="mr-1.5 rounded-sm bg-wine px-1.5 py-0.5 text-[10px] font-bold tracking-[0.08em] text-cream" data-id="element-235" data-mp="30jxfxl8pptc">
                          BONUS
                        </span>}
                      {item.label}
                    </span>
                  </li>;
            })}
            </ul>

            <div className="mx-auto mt-8 max-w-xl text-left" data-id="element-236" data-mp="1jek0hhfdtvkt">
              <p className="text-sm leading-6 text-cream/70" data-id="element-237" data-mp="1oddd77muhijx">
                You could continue collecting random combinations, saved videos
                and disconnected teaching resources.
              </p>
              <p className="mt-3 text-sm font-semibold text-champagne" data-id="element-238" data-mp="33y5jwzv46b8v">
                Or you can have:
              </p>
              <ul className="mt-3 flex flex-wrap gap-1.5" data-id="element-239" data-mp="2z4ku3v3ocnkr">
                {alternatives.map(item => <li key={item} className="rounded-full border border-gold/30 bg-white/5 px-2.5 py-1 text-xs font-medium text-cream" data-id="element-240" data-mp="2u5881ckmnkj8">
                    {item}
                  </li>)}
              </ul>
              <p className="mt-3 text-sm leading-6 text-cream/70" data-id="element-241" data-mp="2g81rlondlxx6">
                All organized inside one professional 6-in-1 teaching system.
              </p>
            </div>

            <PriceTag label="Today" className="mt-10" data-id="element-242" data-mp="ef3sjb30a93s" />
            <div data-id="element-243" data-mp="9h2bevp54juy">
              <CheckoutButton className="mt-7 w-full sm:w-auto" data-id="element-244" data-mp="9gk679ki2vaw">
                GET THE COMPLETE 6-IN-1 SALSA & BACHATA TEACHING SYSTEM
              </CheckoutButton>
            </div>
            <div className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-medium text-cream/70" data-id="element-245" data-mp="28o0m8jhd1zhb">
              {trustItems.map(({
              icon: Icon,
              label
            }) => <span key={label} className="flex items-center gap-1.5" data-id="element-246" data-mp="1tx1hjjjnbv30">
                  <Icon size={14} strokeWidth={1.75} className="text-gold" aria-hidden="true" data-id="element-247" data-mp="1yyz4anr9980p" />
                  {label}
                </span>)}
            </div>
          </div>
        </motion.div>

        <div className="mx-auto mt-14 max-w-2xl text-center" data-id="element-248" data-mp="2rm3gbcormmlz">
          <p className="font-display text-2xl font-semibold text-cream sm:text-3xl" data-id="element-249" data-mp="2dnvb6hhksezq">
            What Salsa and Bachata instructors need is not more random
            information.
          </p>
          <p className="mt-3 font-display text-xl italic text-champagne" data-id="element-250" data-mp="127ov32cyhhv8">
            They need structure. They need a system they can see, understand
            and use.
          </p>
          <p className="mt-5 text-base leading-7 text-cream/70" data-id="element-251" data-mp="ypho1ytnybcd">
            With Salsa & Bachata Instructor Ready, you do not have to begin
            every class from an empty page. You already have the framework.
            You already have the progression. You already have the visual
            teaching tools.
          </p>
          <p className="mt-4 text-base font-medium leading-7 text-cream" data-id="element-252" data-mp="13qf342jdmp9n">
            And with 150 ready-to-teach classes, you already have the class.
          </p>
        </div>
      </div>
    </section>;
}